<template>
    <div>
        <div class="title">Edit Recurring Viber Campaign {{ campaign.id }}</div>
        <edit-viber-campaign
            :campaign="campaign"
            :submit-loading="submitLoading"
            @updateCampaign="updateViberCampaign"
            @cancel="returnToInfoList"
        />
        <alert :show-alert="alert.show" :message="alert.message" :type="alert.type" />
    </div>
</template>

<script>
    import recurringViberCampaignService from '@/services/recurring-viber-campaign-service'
    import editViberCampaign from '@/components/ViberCampaignEditRecurring.vue'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { Alert, editViberCampaign },
        data() {
            return {
                campaign: {},
                submitLoading: false,
                alert: {
                    show: false,
                    message: '',
                    type: null
                }
            }
        },
        computed: {
            getCurrentViberRecurrentCampaign() {
                return this.campaign ?? this.$store.getters.getCurrentRecurringViberCampaign
            }
        },
        created() {
            this.fetchViberCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchViberCampaignById(id) {
                recurringViberCampaignService.getViberCampaignById(id)
                    .then(resp => {
                        this.campaign = resp.data
                    })
                    .catch(err => {
                        if (err.status === 404) {
                            return this.returnToInfoList()
                        }
                        throw err
                    })
            },
            updateViberCampaign(newCampaign) {
                this.submitLoading = true
                this.campaign = structuredClone(newCampaign)
                recurringViberCampaignService.updateViberCampaign(this.campaign).then(() => {
                    this.setAlert('Campaign Updated', 'success')
                    setTimeout(() => { this.$router.push(`/recurring-viber/${this.getCurrentViberRecurrentCampaign.id}`) }, 3000)
                }).catch(error => {
                    this.setAlert('Error updating the campaign' + error.response.data.message, 'error')
                }).finally(() => {
                    this.submitLoading = false
                })
            },
            returnToInfoList() {
                this.$router.push('/recurring-viber/')
            },
            setAlert(message, type) {
                this.alert.show = true
                this.alert.message = message
                this.alert.type = type
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
